import { render, staticRenderFns } from "./RejectionType.vue?vue&type=template&id=9865dade&scoped=true&"
import script from "./RejectionType.vue?vue&type=script&lang=js&"
export * from "./RejectionType.vue?vue&type=script&lang=js&"
import style0 from "./RejectionType.vue?vue&type=style&index=0&id=9865dade&prod&lang=css&"
import style1 from "./RejectionType.vue?vue&type=style&index=1&id=9865dade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9865dade",
  null
  
)

export default component.exports